/**
 * Mousai Commerce - product page behaviour
 *
 * Two jobs:
 *  1. Quantity breaks write the chosen quantity into the real product form.
 *  2. Sticky ATC mirrors the main button once the real one scrolls away.
 *
 * The form is the single source of truth. Nothing here holds its own state.
 */
(() => {
  const form = document.querySelector('.product-form');
  if (!form) return;

  const quantityInput = form.querySelector('[data-quantity-input]');

  /* ---------------------------------------------------------------- breaks */
  const breaks = document.querySelector('[data-quantity-breaks]');

  if (breaks && quantityInput) {
    const sync = () => {
      const checked = breaks.querySelector('.qbreaks__radio:checked');
      if (!checked) return;
      quantityInput.value = checked.value;
      // Let the sticky bar (and any app) know the price on screen changed.
      document.dispatchEvent(
        new CustomEvent('mousai:quantity-change', {
          detail: { quantity: Number(checked.value), total: Number(checked.dataset.total) }
        })
      );
    };

    breaks.addEventListener('change', sync);
    sync();

    // Arrow keys move between tiers natively because they're one radio group;
    // this just makes sure the visual selection is announced.
    breaks.querySelectorAll('.qbreaks__radio').forEach((radio) => {
      radio.addEventListener('focus', () => radio.closest('.qbreaks__tier')?.scrollIntoView({ block: 'nearest' }));
    });
  }

  /* ------------------------------------------------------------ sticky atc */
  const sticky = document.querySelector('[data-sticky-atc]');
  const mainButton = form.querySelector('button[name="add"]');

  if (sticky && mainButton) {
    sticky.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(mainButton);
      } else {
        mainButton.click();
      }
    });

    const priceEl = sticky.querySelector('[data-sticky-price]');
    const money = (cents) => {
      const format = window.themeSettings?.moneyFormat || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    document.addEventListener('mousai:quantity-change', (e) => {
      if (priceEl && Number.isFinite(e.detail.total)) priceEl.textContent = money(e.detail.total);
    });

    // Show the bar only once the real button has left the viewport.
    const watcher = new IntersectionObserver(
      ([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting),
      { rootMargin: '0px 0px -60px 0px' }
    );
    watcher.observe(mainButton);
  }
})();
